import { Link } from "react-router-dom";
import { useLocalePath, useT } from "../../i18n";
import { SITE_IMAGERY } from "../../config/siteImagery";
import { ResponsiveImage } from "../ResponsiveImage";
import { Reveal } from "../Reveal";
import { Phrases } from "../Phrases";

export const SourcingSection = ({ index = "03" }) => {
  const t = useT();
  const lp = useLocalePath();
  const steps = t("sourcing.steps");

  return (
    <section data-testid="sourcing-section" className="grid bg-charcoal text-white lg:grid-cols-2">
      <div className="relative aspect-[4/3] overflow-hidden sm:aspect-[16/9] lg:aspect-auto lg:min-h-[760px]">
        <ResponsiveImage image={SITE_IMAGERY.sourcing} sizes="(min-width: 1024px) 50vw, 100vw" className="zoom-on-view absolute inset-0 h-full w-full object-cover" />
      </div>
      <div className="flex items-center px-5 py-20 sm:px-8 sm:py-24 lg:px-16 lg:py-32 xl:px-24">
        <Reveal className="max-w-xl">
          <p className="eyebrow flex items-center gap-4 text-white/55">
            <span className="tabular-nums">{index}</span>
            <span className="h-px w-8 bg-current" aria-hidden />
            {t("sourcing.eyebrow")}
          </p>
          <h2 className="h-section font-display mt-5" data-testid="sourcing-title"><Phrases text={t("sourcing.title")} /></h2>
          <p className="mt-6 text-white/65">{t("sourcing.body")}</p>
          <ol className="mt-12 border-t border-white/10">
            {steps.map((s, i) => (
              <li key={s.title} className="grid grid-cols-[3rem_1fr] border-b border-white/10 py-5">
                <span className="text-[11px] tabular-nums tracking-[0.2em] text-white/40">0{i + 1}</span>
                <div>
                  <p className="font-medium">{s.title}</p>
                  <p className="mt-1 text-sm text-white/55">{s.body}</p>
                </div>
              </li>
            ))}
          </ol>
          <Link to={lp("sourcing")} className="btn btn-light mt-12" data-testid="sourcing-cta">
            {t("sourcing.cta")}
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
